import { Link } from "wouter";
import { ArrowRight } from "lucide-react";
import type { CalculatorItem } from "@/data/calculators";
import { withTrailingSlash } from "@/lib/urls";

export function CalculatorCard({ calculator }: { calculator: CalculatorItem }) {
  return (
    <Link href={withTrailingSlash(`/calculator/${calculator.slug}`)} className="calculator-card">
      <span className="card-category">{calculator.categoryName}</span>
      <h3>{calculator.title}</h3>
      <p>{calculator.description}</p>
      <strong className="card-link">Open calculator <ArrowRight size={14} /></strong>
    </Link>
  );
}
